import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();

export const setPreferences = (data) => {
  return API.post(`settings/preferences/preferences`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setAllowedDomains = (data) => {
  return API.post(`settings/preferences/allowed_domains`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setEntityRules = (data) => {
  return API.post(`settings/preferences/entity_rules`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const setPACheckRules = (data) => {
  return API.post(`settings/preferences/pa_check_rules`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getPolicyTypes = (data) => {
  return API.get(`settings/customise/list/policy-types`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const addUpdatePortalConfig = (data) => {
  return API.post(`settings/preferences/preferences`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getConfigData = (payload) => {
  return API.get(`settings/config`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const saveAllowedDomains = (data) => {
  return API.post(`settings/preferences/allowed_domains`, data, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const getVendors = () => {
  return API.get(`/settings/customise/list/sourcing`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};
